import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@primer/react';

var Divider = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 1px;\n  background-color: ", ";\n  width: 100%;\n"], ["\n  height: 1px;\n  background-color: ", ";\n  width: 100%;\n"])), themeGet("colors.actionListItem.inlineDivider"));
var LTDivider = function LTDivider() {
  return /*#__PURE__*/React.createElement(Divider, null);
};
var templateObject_1;

export { LTDivider as default };
